import styled, {css} from 'styled-components';
import breakpoints from '@/theme/constants/breakpoints';
import {sizePx} from '@/theme/helpers/size';
import typography from '@/theme/typography';
import Accordion from '@/molecules/Accordion/Accordion';
import StyledIcon from '@/atoms/Icon/styles';
import colors from '@/theme/constants/colors';

const showForDesktop = css`
  @media only screen and ${breakpoints.device.m} {
    display: block;
  }
`;

export const StyledTitle = styled.p`
  ${typography.Subtitle1}
  margin-bottom: ${sizePx(10)};
  display: none;
  ${showForDesktop}
`;

export const StyledLink = styled.a`
  ${typography.Body1}
  display: block;
  width: fit-content;

  &:not(:last-child) {
    margin-bottom: ${sizePx(5)};
  }

  ${StyledIcon} {
    display: inline-block;
    margin-right: ${sizePx(3)};
    width: ${sizePx(10)};
    text-align: center;
  }

  &:hover,
  &:focus-visible {
    color: ${colors.red100};
    outline: none;
  }
`;
export const StyledBody = styled.div`
  display: none;
  ${showForDesktop}
`;

export const StyledAccordion = styled(Accordion)`
  @media only screen and ${breakpoints.device.m} {
    display: none;
  }
`;

export const StyledAboutLinks = styled.div``;
